












































































































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import Toggle from '@/components/Toggle.vue';
import FormInput from '@/components/FormInput.vue';
import Select from '@/components/Select.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import api, { apiSandbox, apiProduction } from '@/libs/api';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

import DualListBox from 'dual-listbox-vue';
import 'dual-listbox-vue/dist/dual-listbox.css';

import Multiselect from 'vue-multiselect';
import MultiText from '@/components/MultiText.vue';
import InputCurrency from '@/components/InputCurrency.vue';

@Component({
  components: {
    Button,
    Toggle,
    FormInput,
    LayoutContent,
    LayoutTitle,
    Checkbox,
    Loader,
    DualListBox,
    Multiselect,
    Select,
    MultiText,
    InputCurrency,
  },
})

export default class ModalConfigurator extends Vue {
  dataSandbox = {
    bayarind_endpoint: '',
    email: '',
    flag_url: '',
    disburse_confirmation_url: '',
    key: '',
    merchant_code: '',
    status: true,
    type_fee: '',
    fee: '',
  };

  dataProduction = {
    bayarind_endpoint: '',
    email: '',
    flag_url: '',
    key: '',
    merchant_code: '',
    status: false,
    type_fee: '',
    fee: '',
  };

  showFeeSharingAS = false;
  showFeeSharingOBR = false;
  activateReseller = false;
  activateMultiLayer = false;
  activeNotificationLimitBalance = false;
  isReseller = false;
  // merchantCode = this.$route.params.code;

  notificationList = {
    min_value: 0,
    emails: [],
  }

  dataMultiLayer = {
    approvalLevel: [],
    pic1: [],
    pic2: [],
  };

  // approvalLevel = 1;

  sourceList = [];
  destinationList = [];

  isLoading = true;

  isDisabled = false;

  async mounted() {
    await this.getMerchantList();
    await this.getDetailSandbox();
    await this.getDetailProduction();
    await this.getMerchantReseller();
    // await this.getNotificationList();
    this.isLoading = false;
  }

  loadingSendEmail = false;
  loadingConfigSandbox = false;
  loadingConfigProd = false;

  // @Prop() readonly merchantCode!: any;

  // eslint-disable-next-line class-methods-use-this
  toggleModal() {
    // this.$emit('toggleModal', false);
  }

  async activateProduction() {
    await apiProduction.post('/disbursement/merchant', {
      merchant_code: this.$route.params.code,
      status: this.dataProduction.status ? 'ACTIVE' : 'INACTIVE',
    }).then(() => {
      showToast(ToastType.SUCCESS, 'Success', 'Production activated');
    }).catch((err) => {
      showToast(ToastType.FAILED, 'Oops… Sorry', err.response?.data.error);
      // console.log('err', err.response);
    });
    this.getDetailProduction();
  }

  async getDetailSandbox() {
    await apiSandbox.get(`/disbursement/merchant/${this.$route.params.code}`).then((res) => {
      console.log('res', res);
      if (res.data) {
        this.dataSandbox = { ...res.data, status: res.data.status === 'ACTIVE' };
      } else {
        this.dataSandbox.merchant_code = '';
      }
    }).catch(() => {
      this.dataSandbox.merchant_code = '';
    });
    this.isDisabled = false;
  }

  async getDetailProduction() {
    await apiProduction.get(`/disbursement/merchant/${this.$route.params.code}`).then((res) => {
      if (res.data) {
        this.dataProduction = { ...res.data, status: res.data.status === 'ACTIVE' };
      } else {
        this.dataProduction.merchant_code = '';
      }
    }).catch(() => {
      this.dataProduction.merchant_code = '';
    });
    this.isDisabled = false;
  }

  saveSandbox() {
    this.loadingConfigSandbox = true;
    this.isDisabled = true;
    apiSandbox.put('/disbursement/merchant', {
      ...this.dataSandbox, status: this.dataSandbox.status ? 'ACTIVE' : 'INACTIVE',
    }).then((res) => {
      showToast(ToastType.SUCCESS, 'Success', 'Data has been saved');
      this.getDetailSandbox();
      this.loadingConfigSandbox = false;
      console.log('res', res);
    }).catch((err) => {
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to save data');
      this.loadingConfigSandbox = false;
      console.log('err', err);
    });
  }

  saveProduction() {
    this.loadingConfigProd = true;
    this.isDisabled = true;
    apiProduction.put('/disbursement/merchant', {
      ...this.dataProduction, status: this.dataProduction.status ? 'ACTIVE' : 'INACTIVE',
    }).then((res) => {
      showToast(ToastType.SUCCESS, 'Success', 'Data has been saved');
      this.getDetailProduction();
      this.loadingConfigProd = false;
      console.log('res', res);
    }).catch((err) => {
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to save data');
      this.loadingConfigProd = false;
      console.log('err', err);
    });
  }

  async saveReseller() {
    try {
      if (this.activateReseller && this.destinationList.length === 0) {
        showToast(ToastType.FAILED, 'Data Validation Error', 'Silahkan pilih merchant reseller');
        return;
      }
      const submitData: any = {
        parent_merchant_code: this.$route.params.code,
        show_fee_sharing: this.showFeeSharingAS,
        show_fee_sharing_merchant: this.showFeeSharingOBR,
        merchant_code: this.destinationList.map((val: any) => val.merchant_code),
        status: this.activateReseller ? 'ACTIVE' : 'INACTIVE',
      };
      await api.post('/disbursement/merchant-reseller', submitData);
      // await api.post('/disbursement/merchant/fee-sharing', {
      //   merchant_code: this.$route.params.code,
      //   enable: this.showFeeSharingAS,
      // });
      showToast(ToastType.SUCCESS, 'Success', 'Data has been saved');
    } catch (err) {
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to save data');
      console.log('err', err);
    }
  }

  // async saveNotifLimitBalance() {
  //   try {
  //     if (this.activeNotificationLimitBalance && this.notificationList.emails.length === 0) {
  //       showToast(ToastType.FAILED, 'Data Validation Error', 'Please select at least one email');
  //       return;
  //     }
  //     const params = {
  //       is_active: this.activeNotificationLimitBalance,
  //       min_value: this.notificationList.min_value,
  //       emails: this.notificationList.emails,
  //     };
  //     await api.put(`/disbursement/notification-limit/${this.$route.params.code}`, params);
  //     // this.toggleModal();
  //     showToast(ToastType.SUCCESS, 'Success', 'Data has been saved');
  //   } catch (error) {
  //     showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to save data');
  //   }
  // }

  sendEmail(targetEnv: string) {
    this.loadingSendEmail = true;
    (targetEnv === 'sandbox' ? apiSandbox : apiProduction).post('/disbursement/merchant/send-credentials', {
      merchant_code: this.$route.params.code,
      email: targetEnv === 'sandbox' ? this.dataSandbox.email : this.dataProduction.email,
    }).then((res) => {
      showToast(ToastType.SUCCESS, 'Success', 'Send email success');
      this.loadingSendEmail = false;
      console.log('res', res);
    }).catch((err) => {
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to send email');
      this.loadingSendEmail = false;
      console.log('err', err);
    });
  }

  onChangeList(params: any) {
    this.sourceList = params.source.sort((a: any, b: any) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    this.destinationList = params.destination.sort((a: any, b: any) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }

  async getMerchantList() {
    const { data } = await api.get('/disbursement/merchants');
    if (data) {
      this.sourceList = data.sort((a: any, b: any) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    }
    return true;
  }

  // async getNotificationList() {
  //   const { data } = await api.get(`/disbursement/notification-limit/${this.$route.params.code}`);
  //   console.log(data?.response_data?.min_value === undefined, 'ini data notification');
  //   if (data?.response_data?.min_value === undefined) {
  //     this.notificationList = {
  //       min_value: 0,
  //       emails: [],
  //     };
  //   } else {
  //     this.notificationList = data.response_data;
  //   }

  //   console.log(this.notificationList, 'notlist ... -<');

  //   return true;
  // }

  async getMerchantReseller() {
    await api.get(`/disbursement/merchant-reseller/${this.$route.params.code}`).then(({ data }) => {
      if (data) {
        this.isReseller = data.is_reseller;
        this.activateReseller = data.is_reseller;
        this.showFeeSharingOBR = data.show_fee_sharing_merchant;
        // eslint-disable-next-line max-len
        if (data.merchants_reseller.length === 0) {
          this.isReseller = false;
        }
        const merchantReseller = data.merchants_reseller.map((val: any) => val.merchant_code);
        this.destinationList = this.sourceList.filter((item: any) => merchantReseller.includes(item.merchant_code));
        this.sourceList = this.sourceList.filter((item: any) => !merchantReseller.includes(item.merchant_code));
      }
    });
    await api.get(`/disbursement/merchant/fee-sharing-configuration/${this.$route.params.code}`).then(({ data }) => {
      if (data) {
        this.showFeeSharingAS = data.show_fee_sharing;
      }
    });
  }
}
